export const FORM_STATUS = {
  OFF: 'OFF',
  LOGIN: 'LOGIN',
  SIGNUP: 'SIGNUP',
  FORGET_PASSWORD: 'FORGET_PASSWORD',
};
